import { render } from "./SiteFooter.vue?vue&type=template&id=6615dd20"
const script = {}

import "./SiteFooter.vue?vue&type=style&index=0&id=6615dd20&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__